import React from 'react';
import { useCart } from '../context/CartContext.tsx';
import { loadStripe } from '@stripe/stripe-js';
import axios from 'axios';

// Ladda Stripe
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY as string); 
// 👆 Om du kör Vite
// Använder du Create React App, skriv: process.env.REACT_APP_STRIPE_PUBLIC_KEY as string

// Typ för varje objekt i kundvagnen
interface CartItem {
  name: string;
  selectedSize: string;
  quantity: number;
  price?: number;
  [key: string]: any; // om du har fler egenskaper
}

const Checkout: React.FC = () => {
  const { cartItems } = useCart();

  // Hämta userId från localStorage (eller använd en global state om användaren är inloggad)
  const userId = JSON.parse(localStorage.getItem("user") || "{}").userId;

  // Skapa en funktion för att hämta kundinformation (från tex. formfält eller lokal lagring)
  const getCustomerInfo = () => {
    return {
      name: 'Heba',
      email: 'heb95der@gmail.com',
      address: 'Sernanaders väg 14',
      phone: '0736449569',
      city: 'Uppsala',
      country: 'Sverige',
      zip: '75262',
      countryCode: 'SE'
    };
  };

  const handlePayment = async (): Promise<void> => {
    const customerInfo = getCustomerInfo(); // Hämta kundinformation

    try {
      const res = await axios.post('http://localhost:5001/api/checkout/create-checkout-session', {
        cartItems,
        customerInfo, // Skicka kundinformation till backend
        shippingCost: 46, // Exempel på fraktkostnad, kan ändras dynamiskt
        userId, // Skicka med userId
      });

      if (res.status !== 200) {
        throw new Error(`Något gick fel när sessionen skulle skapas. Statuskod: ${res.status}`);
      }

      const session = res.data;
      const stripe = await stripePromise;

      if (!stripe) {
        throw new Error('Stripe kunde inte laddas.');
      }

      const { error } = await stripe.redirectToCheckout({
        sessionId: session.id,
      });

      if (error) {
        console.error('Stripe Checkout Error:', error);
      }
    } catch (error) {
      console.error('Fel vid betalning:', error);
      alert('Något gick fel, försök igen senare.');
    }
  };

  return (
    <div>
      <h2>Checkout</h2>
      {cartItems.length === 0 ? (
        <p>Din varukorg är tom.</p>
      ) : (
        <ul>
          {cartItems.map((item, index) => (
            <li key={index}>
              <p>
                {item.name} – {item.selectedSize} – {item.quantity} st
              </p>
            </li>
          ))}
        </ul>
      )}
      <button onClick={handlePayment}>Betala</button>
    </div>
  );
};

export default Checkout;
